import * as React from 'react';
import history from '@utils/History';
import ReactGA from 'react-ga'

class GAListener extends React.Component {
    componentDidMount() {
        ReactGA.set({ page: history.location.pathname });
        ReactGA.pageview(history.location.pathname);
    }

    render() {
        return this.props.children;
    }
}

export default GAListener;


// WEBPACK FOOTER //
// ./src/utils/analytics/GAListener.ts